import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HomeHotelIcon = _ref => {
  let {
      size = "36",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    clipPath: "url(#clip0_25443_13194)"
  }, __jsx("path", {
    d: "M15.5556 8.88889V0H4.44444V4.44444H0V20H8.88889V15.5556H11.1111V20H20V8.88889H15.5556ZM4.44444 17.7778H2.22222V15.5556H4.44444V17.7778ZM4.44444 13.3333H2.22222V11.1111H4.44444V13.3333ZM4.44444 8.88889H2.22222V6.66667H4.44444V8.88889ZM8.88889 13.3333H6.66667V11.1111H8.88889V13.3333ZM8.88889 8.88889H6.66667V6.66667H8.88889V8.88889ZM8.88889 4.44444H6.66667V2.22222H8.88889V4.44444ZM13.3333 13.3333H11.1111V11.1111H13.3333V13.3333ZM13.3333 8.88889H11.1111V6.66667H13.3333V8.88889ZM13.3333 4.44444H11.1111V2.22222H13.3333V4.44444ZM17.7778 17.7778H15.5556V15.5556H17.7778V17.7778ZM17.7778 13.3333H15.5556V11.1111H17.7778V13.3333Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_25443_13194"
  }, __jsx("rect", {
    width: "20",
    height: "20",
    fill: "white"
  }))));
};
export default HomeHotelIcon;